import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=69a517fd"
import script from "./Factura.vue?vue&type=script&lang=js"
export * from "./Factura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports